import { Link, useLocation } from "react-router-dom";
import styled from "styled-components";

import logoKingsOfGames from "../images/logo_kings_of_games.svg";
import { device, paddingMedium, paddingSmall } from "../variables";
import Heading from "./shared/Heading";

const HIDDEN_PATHS = new Set(["/status"]);

const Navigation = () => {
  const location = useLocation();

  if (HIDDEN_PATHS.has(location.pathname)) {
    return null;
  }

  return (
    <Wrapper>
      <Link to="/">
        <Flex>
          <Image src={logoKingsOfGames} />
          <StyledHeading fontSize="20px" uppercase>
            Kings of games
          </StyledHeading>
        </Flex>
      </Link>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  padding: ${paddingSmall};
  background-color: black;
  position: relative;
  z-index: 4;
  height: 100px;
  display: flex;
  align-items: center;

  @media ${device.laptop} {
    padding: ${paddingMedium};
  }
`;

const Flex = styled.div`
  display: flex;
  align-items: center;
`;

const Image = styled.img`
  width: 50px;
  margin-right: 15px;

  @media ${device.laptop} {
    margin-right: 30px;
  }
`;

const StyledHeading = styled(Heading)`
  padding-top: 10px;
`;

export default Navigation;
